module.exports = __webpack_public_path__ + "static/media/epsilonLogo.1db59a50.svg";